<template>
  <!-- 用能查询 -->
  <el-row class="load-analysis flex-grow-1" type="flex" :gutter="12">
    <el-col :span="5" class="tree-container d-flex flex-column">
      <project-tree-selector
        class="flex-grow-1"
        @select-node="selectNodeListener"
        @node-list="nodeListChangeListener"
        levelType="byq"
      ></project-tree-selector>
    </el-col>
    <!-- 右側 -->
    <el-col :span="19" class="d-flex flex-column">
      <div class="breadcrumbs-contain d-flex align-items-center section-container"
       :class="{'dark':skinType}">
         <SectionTitle title="负载分析"></SectionTitle>
        <breadcrumbs
          :selectNode="selectNode"
          :nodeList="nodeList"
        ></breadcrumbs>
      </div>
      <!-- 條件查詢 -->
      <div class="selector-container section-container" :class="{'dark':skinType}">
        <el-form :inline="true" style="text-align: left" size="small">
          <period-date-selector
            :isDateSelector="false"
            @startEndDate="startEndDateListener"
          ></period-date-selector>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button  @click="exportTable">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table  size="small"
        class="energy-table flex-grow-1 d-flex flex-column"
        :data="tableData"
        height="0"
        stripe
        ref="table"
        style="width: 100%"
        :class="{'dark':skinType}"
        :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
      >
      <el-table-column prop="TransformerName" label="变压器名称">
      </el-table-column>
      <el-table-column prop="Volume" label="容量(kW)"> </el-table-column>
     <el-table-column label="最大负载(kW)">
        <template slot-scope="scope">
          {{ (scope.row.Max* scope.row.Volume/100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Max" label="最大负载率(%)"> </el-table-column>
      <el-table-column prop="MaxDate" label="发生时间"> </el-table-column>
      <el-table-column label="最小负载(kW)">
        <template slot-scope="scope">
          {{ (scope.row.Min* scope.row.Volume/100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Min" label="最小负载率(%)"> </el-table-column>
      <el-table-column prop="MinDate" label="发生时间"> </el-table-column>
      </el-table>
      <div class="d-flex section-container" style="padding:1rem" :class="{'dark':skinType}">
        <el-pagination
		  :page-size="pageInfo.size"
          v-if="pageInfo.total"
          style="margin-left: auto"
          :class="{'text-white':skinType}"
          background
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          :current-page.sync="pageIndex"
        >
        </el-pagination>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import ProjectTreeSelector from '@/components/utils/project-tree-selector.vue';
import PeriodDateSelector from '@/components/energy-analysis/components/period-date-selector.vue';
import { loadAnalysis } from '@/api/statistic/statistic';
import Breadcrumbs from '@/components/utils/breadcrumbs.vue';
import { exportExcel } from '@/utils/utils';
import SectionTitle from '@/components/utils/section-title.vue';

export default {
  name: 'load-analysis',
  components: {
    ProjectTreeSelector,
    PeriodDateSelector,
    Breadcrumbs,
    SectionTitle,
  },
  data() {
    return {
      pageIndex: 1,
      startEndDate: null,
      selectNode: null,
      pageInfo: {
        index: 1,
        size: 40,
		total: 0
      },
      tableData: [],
      options: [
        {
          label: '上日',
          value: 0,
        },
        {
          label: '上周',
          value: 1,
        },
        {
          label: '上月',
          value: 2,
        },
        {
          label: '上年',
          value: 3,
        },
      ],
      compareDateType: 0,
      nodeList: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    pageIndex() {
      this.requestLoadAnalysis();
    },
    selectNode() {
      this.requestLoadAnalysis();
    },
    startEndDate() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestLoadAnalysis();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    // 导出表格
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
    nodeListChangeListener(list) {
      this.nodeList = list;
    },
    selectNodeListener(node) {
      this.pageIndex = 1;
      this.selectNode = node;
    },
    startEndDateListener(datePeriod) {
      this.startEndDate = datePeriod;
    },
    requestLoadAnalysis() {
      this.tableData = [];
      if (this.startEndDate === null) {
        return;
      }
      if (this.selectNode === null) {
        return;
      }
      if (this.selectNode.oType !== 'byq') {
        return;
      }
      loadAnalysis({
        oType: this.selectNode.oType,
        oIDstr: this.selectNode.IdStr,
        BeginDate: this.startEndDate.start,
        EndDate: this.startEndDate.end,
        page: this.pageIndex,
        rows: this.pageInfo.size,
      }).then((res) => {
		console.log('负载-------------->',res)
        if (res !== null && res.list) {
          this.tableData = res.list;
          this.pageInfo.total = res.total;
          return;
        }
        this.tableData = res || [];
        this.pageInfo.total = 0;
      }).catch(() => {
        this.tableData = [];
        this.pageInfo.total = 0;
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onSubmit() {
      this.requestLoadAnalysis();
    },
  },
};
</script>
<style scoped>
.breadcrumbs-contain {
  padding: 1rem;
  margin-bottom: 1rem;
}
</style>
